import { USERS } from "../Constants/Endpoinst";
import { ApiRequestInterceptor } from "./apiRequest";

export const fetchEmpleados = async (lastKey = null) => {
    const method = "GET";
    const loginData = JSON.parse(localStorage.getItem("logindata") || "{}");
    const token = loginData?.data?.token;

    if (!token) {
        throw new Error("No hay token de autenticación");
    }

    const headers = {
        Authorization: `Bearer ${token}`
    };

    let url = USERS.getEmpleados;
    if (lastKey) {
        url += `?lastKey=${encodeURIComponent(lastKey)}`;
    }

    const response = await ApiRequestInterceptor(url, method, undefined, headers);

    if (response.code === 200 && response.data?.empleados) {
        // Ahora el backend te devuelve nextKey
        return {
            empleados: response.data.empleados,
            nextKey: response.data.nextKey
        };
    } else {
        const errorMessage = response?.data?.error || "Error al traer empleados";
        throw new Error(errorMessage);
    }
};

